import React from 'react'
import { Button } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import { exportTableToExcel } from '../../utils/exportTable'
import openNotification from './Notification/openNotification '
import { hasPermission } from '../../config-func'

// Tạm thời hard: chỉ tài khoản admin.g18@gmail.com mới thấy nút Export.
const EXPORT_ALLOWED_EMAIL = 'admin.g18@gmail.com'

/**
 * Nút "Export Excel" xuất đúng dữ liệu đang hiển thị trên bảng (FE tự xuất).
 * Dùng lại chính `columns` (initialColumns) và `data` (data.list) của trang.
 */
const ExportButton = ({
  columns = [],
  data = [],
  fileName = 'export',
  sheetName = 'Sheet1',
  permission,
  disabled = false,
  label = 'Export Excel',
  ...rest
}) => {
  // Điều kiện hiển thị: vừa đúng tài khoản admin hard-code, vừa có quyền export.
  const currentEmail = (
    localStorage.getItem('user_email') || ''
  ).toLowerCase()
  if (currentEmail !== EXPORT_ALLOWED_EMAIL) {
    return null
  }

  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  if (permission && !hasPermission(permission, permissions)) {
    return null
  }

  const handleExport = () => {
    if (!data || data.length === 0) {
      openNotification('error', 'Không có dữ liệu để xuất')
      return
    }
    try {
      exportTableToExcel({ columns, data, fileName, sheetName })
    } catch (e) {
      openNotification('error', 'Xuất file thất bại. Vui lòng thử lại.')
    }
  }

  return (
    <Button type="primary" onClick={handleExport} disabled={disabled} {...rest}>
      <DownloadOutlined />
      {label}
    </Button>
  )
}

export default ExportButton
